module.exports = __webpack_public_path__ + "static/media/pricingbkg.28b1ff69.png";